// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"43d80d48446a10d22b3f","263":"007753c20e5663d9fc8c","791":"d88e63dab18ec90340e8"}[chunkId] + ".js";
};